<template>
	<div class="contianer">
		<!-- 头部标题 -->
		<div class="header">
			<!-- <div class="header-retrun">&lt;</div>
			<div class="header-title">{{classes}}</div> -->
			<van-nav-bar left-text="返回" :title="classes" left-arrow @click-left="onClickLeft"/>
		</div>
		<!-- 间距 -->
		<div class="margin20"></div>
		<!-- 考试题库列表 -->
		<div class="examBank">
			<!-- 搜索框 -->
			<div class="examBank-top">
				<div class="examBank-top_search">					
					<!-- <van-search placeholder="请输入您要搜索的内容" v-model="searchText" /> -->
					<van-search v-model="value" placeholder="请输入搜索关键词" show-action shape="round" @search="onSearch">
						<!-- <div slot="action" @click="onSearch">搜索</div> -->
						<div slot="action" class="examBank-top_text"><van-icon  name="filter-o" />筛选</div>
					</van-search>
				</div>
			</div>
			<!-- 题库列表 -->
			<div class="examBank-box">
				<div class="examBank-box_top">
					<div class="examBank-box_title">
						<ul>
							<li>2018 考试真题题目</li>
						</ul>
					</div>
					<div class="examBank-box_score">90分</div>
				</div>
				<div class="examBank-box_bottom">
					<div class="examBank-box_difficulty">
						<div>200人参考</div>
						<div class="difficulty-flex">难度<van-rate size="9" readonly='true' v-model="difficulty" /></div>
					</div>
					<div class="examBank-box_again" @click="getExamList('/user/ExamList')">重新练习</div>
				</div>
			</div>
			<!--  -->
			<div class="examBank-box">
				<div class="examBank-box_top">
					<div class="examBank-box_title">
						<ul>
							<li>2018 考试真题题目</li>
						</ul>
					</div>
					<div class="examBank-box_score">90分</div>
				</div>
				<div class="examBank-box_bottom">
					<div class="examBank-box_difficulty">
						<div>200人参考</div>
						<div class="difficulty-flex">难度<van-rate size="9" readonly='true' v-model="difficulty" /></div>
					</div>
					<div class="examBank-box_again">重新练习</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"ExamBank",
		data() {
			return {
				classes: '未选择',//选中课程
				searchText:'',//搜索内容
				difficulty:3,//难度星星
			}
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			},
			// 跳转考试内容
			getExamList(url){
				this.$router.push(url)
			}
		},
	}
</script>

<style>
	.contianer{
		width: 100%;
		min-height: 100vh;
		background: #fff;
	}
	/* 头部 */
	.header{
		width: 100%;
		position: relative;
		font-size: 0.875rem;
	}
	.header-title{
		text-align: center;
		line-height: 2.5rem;
	}
	.header-retrun{
		height: 2.5rem;
		line-height: 2.5rem;
		position: absolute;
		top: 0;
		left: 0.625rem;
		
	}
	/* 间距 */
	.margin20{
		width: 100%;
		height: 0.625rem;
		background: #F5F4F9;
	}
	/* 考试题库列表 */
	.examBank{
		width: 90%;
		margin: 0 auto;
		background: #fff;
		
	}
	.examBank-box{
		margin-bottom: 0.625rem;
		border-bottom: 1px solid #EBEDEF;
	}
	.examBank-box_top{
		display: flex;
		justify-content: space-between;
	}
	.examBank-box_bottom{
		margin-top: 0.3125rem;
		width: 100%;
		height: 1.5625rem;
		display: flex;
		justify-content: space-between;
		
	}
	.examBank-box_title{
		font-size: 0.6875rem;
		color: #333;
	}
	.examBank-box_score{
		font-size: 0.625rem;
		color: #FF795C;
	}
	.examBank-box_difficulty{
		width: 60%;
		font-size: 0.5625rem;
		color: #999;
		display: flex;
		justify-content: space-between;
	}
	.examBank-box_again{
		font-size: 0.625rem;
		color: #fff;
		width: 3.5625rem;
		height: 1.125rem;
		border-radius: 0.5625rem;
		background: #FF795C;
		text-align: center;
		line-height: 1.125rem;
	}
	.difficulty-flex{
		display: flex;
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/ExamBank.vue